import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import { capitalizeFirstLetter } from "../../utils/helpers";

const PlanSummary = ({ plan }) => {
  const {
    name,
    price,
    billable,
    description,
    features,
    discounted_amount,
    // stripe_price,
  } = plan;

  return (
    <div className="bg-white rounded-xl shadow-md p-4 border border-blue-100 my-2 flex flex-col h-fit max-w-lg">
      <div>
        <h3 className="text-lg font-bold text-gray-900">
          {capitalizeFirstLetter(name)}
        </h3>
        <div className="flex items-baseline mt-1">
          <h3 className="text-xl font-semibold text-blue-600">
          {/* {stripe_price} */}  ${price}
          </h3>
          <span className="text-sm text-gray-600 ml-1">/ {billable}</span>
        </div>
        {discounted_amount > 0 && (
          <p className="text-sm text-gray-500 line-through">
            ${discounted_amount} / {billable}
          </p>
        )}
        <p className="text-sm text-gray-600 mt-2">
          {capitalizeFirstLetter(description)}
        </p>
        <div className="mt-3">
          {features?.map((feature, index) => (
            <div
              key={index}
              className="flex items-center text-gray-700 text-xs mt-1"
            >
              <FaCheckCircle className="mr-2 text-blue-500 flex-shrink-0" />
              <span>{feature}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlanSummary;
